import { useState } from "react";
import { ValidationError, object, string } from "yup";
import { FormControl, Grid, Typography } from "@mui/material";
import {
  CommonButton,
  CommonOutlinedButton,
  CustomCheckbox,
  CustomInputLabel,
  CustomMenuItem,
  CustomRequiredInputLabel,
  CustomSelectforFamily,
  CustomTextFeildforFamily,
  formatAmount,
} from "../../common/StyledComponents/StyledFields";
import styles from "../reportSection.module.scss";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import { apiRequest } from "../../../infrastructure/backendService";
import { ClipLoader } from "react-spinners";

const MailingLabelsReport = ({ sendDataToParent, getReportData }: any) => {
  const formFieldsMailingLabels = {
    alphabetSelected: "",
    zipCode: "",
  };

  const [formError, setFormError] = useState<string | null>(null);


  // const [errorMessageMailingLabels, setErrorMessageMailingLabels] =
  //   useState<any>({ ...formFieldsMailingLabels });

    const [formDataMailingLabels, setFormDataMailingLabels] = useState(
        formFieldsMailingLabels
        );
  const [loading, setLoading] = useState(false);

  const [isMailLabelsSelected, setIsMailLabelsSelected] = useState(false);

  const alpha = Array.from(Array(26)).map((e, i) => i + 65);
  const alphabet = alpha.map((x) => String.fromCharCode(x));
  alphabet.unshift("ALL");

  const handleDropdownChange = (field: any, value: any) => {
    setFormDataMailingLabels({
      ...formDataMailingLabels,
      [field]: value,
    });
    setFormError(null); 
  };

  const handleFieldChange = (field: any, value: any) => {
    setFormDataMailingLabels({
      ...formDataMailingLabels,
      [field]: value,
    });
    setFormError(null); 
  };
  const handleCheckBoxChange = ()=>{
    setIsMailLabelsSelected(!isMailLabelsSelected)
    setFormError(null);
  }

  const getMailingLabelsReports = () => {
    const reqBody: any = {
      lastNameStartsWith: formDataMailingLabels.alphabetSelected,
      mailingLabelsWithoutEmailIds: isMailLabelsSelected,
      pagination:true,
      pageNumber:1,
      pageSize:250
    };
    if (formDataMailingLabels.zipCode !== "") {
      reqBody.zipCode = formDataMailingLabels.zipCode;
    }
    setLoading(true);
    apiRequest({
      method: "POST",
      endpoint: "/report-dashboard/reports/devotee/MAILING_LABELS/browser",
      body: JSON.stringify(reqBody),
      includeToken: true,
    })
      .then((res) => {
        setLoading(false);
        sendDataToParent(true, { reqBody,  
          totalElements:res.data[0].totalElements,
          pageSize:res.data[0].pagesize
         });
        const response = res?.data[0]?.data.map((obj: any,index:number) => {
          return {
            "Sr.No.":index+1,
            "Sign-in Name": obj.username,
            "First Name": obj.firstname || "--",
            "Middle Name": obj.middlename || "--",
            "Last Name": obj.lastname || "--",
            Address: obj.address,
            City: obj.city,
            State: obj.state,
            "Zip code": obj.zipcode,
            Country: obj.country,
          };
        });
        getReportData(response);
      })
      .catch((err) => {
        setLoading(false);
      });
  };

  const handleClear = () => {
    setFormDataMailingLabels(formFieldsMailingLabels);
    setIsMailLabelsSelected(false)
    setFormError(null)
  };

  const handlSubmitMailingLabelsReport = async () => {
    // Check if at least one field is filled
    const isFormValid = formDataMailingLabels.alphabetSelected || 
                        formDataMailingLabels.zipCode ||
                        isMailLabelsSelected;

    if (!isFormValid) {
      setFormError("Please select at least one field above.");
      return;
    }

    try {
      // Clear any previous form errors
      setFormError(null);
      
      // Proceed to get the mailing labels report
      getMailingLabelsReports();
    } catch (error) {
      // Handle errors
      console.error(error);
    }
  };
  const AlphabetDropdown = (): React.ReactElement => {
    return (
      <>
        <FormControl className={styles.moveToDropdown}>
          <CustomSelectforFamily
            IconComponent={KeyboardArrowDownIcon}
            defaultValue=""
            id="grouped-select"
            value={formDataMailingLabels.alphabetSelected}
            onChange={(e) => {
              handleDropdownChange("alphabetSelected", e.target.value);
            }}
            MenuProps={{
              PaperProps: {
                sx: {
                  border: "1px solid #F05802",
                  "& ul": {
                    paddingTop: 0,
                    paddingBottom: 0,
                    overflowY: "auto",
                    minHeight: "auto",
                    maxHeight: "300px",
                    "&::-webkit-scrollbar": {
                      width: "8px",
                    },
                    "&::-webkit-scrollbar-thumb": {
                      background: "#F3C539",
                      borderRadius: "6px",
                    },
                  },
                },
              },
            }}
          >
            {alphabet.map((item: any, i: any) => (
              <CustomMenuItem value={item} key={i}>
                {item}
              </CustomMenuItem>
            ))}
          </CustomSelectforFamily>
        </FormControl>
      </>
    );
  };

  return (
    <div className={styles.poojareportsLayout}>
       
      <Grid container spacing={2} sx={{ mt: 0 }}>
        <Grid item xs={12} sm={4}>
          {CustomRequiredInputLabel("Last Name Starts with", false)}
          {AlphabetDropdown()}
        </Grid>
      </Grid>
      <Grid container spacing={2} sx={{ marginTop: "0px" }}>
        <Grid item xs={12} sm={4}>
          <CustomInputLabel>Zip Code</CustomInputLabel>
          <CustomTextFeildforFamily
            style={{ minWidth: "100%", borderRadius: "8px" }}
            fullWidth
            value={formDataMailingLabels.zipCode}
            onChange={(e) => {
              const inputValue = e.target.value;
              handleFieldChange("zipCode", inputValue);
            }}
            className={styles.dateFeild}
          />
        </Grid>
      </Grid>
      <Grid container spacing={2} sx={{ mt: 0 }}>
        <Grid item xs={12} sm={4}>
          <div style={{display:"flex",marginLeft:"-10px"}}>
            <CustomCheckbox
              checked={isMailLabelsSelected}
              // onChange={() => setIsMailLabelsSelected(!isMailLabelsSelected)}
              onChange={handleCheckBoxChange}
            />
            <Typography style={{whiteSpace:"nowrap",marginTop:"6px"}}>
              Mailing labels who do not have email ids
            </Typography>
          </div>
        </Grid>
      </Grid>
      {formError && (
        <Typography sx={{ color: "red", fontSize: "14px", marginBottom: "16px" }}>
          {formError}
        </Typography>
      )}
      <Grid sx={{ mt: 3, display: "flex", gap: "16px" }}>
        <CommonButton
          sx={{ width: "fit-content", height: "38px" }}
          onClick={handlSubmitMailingLabelsReport}
          disabled={loading}
          id="submit"
        >
          {loading ? (
            <>
              <ClipLoader color="#fff" loading={loading} size={15} />
              <span
                style={{
                  marginLeft: "8px",
                  fontSize: "15px",
                  textAlign: "center",
                }}
              >
                Submitting...
              </span>
            </>
          ) : (
            "Submit"
          )}
        </CommonButton>
        <CommonOutlinedButton onClick={handleClear}>Reset</CommonOutlinedButton>
      </Grid>
    </div>
  );
};

export default MailingLabelsReport;
